/** Mirrors backend FloorInboundEvent / FloorOutboundEvent literals. */
export const FloorInboundEvent = {
  LIST: 'list',
  RETRIEVE: 'retrieve',
  MEETINGROOM_STATUS: 'meetingroom_status',
} as const;

export const FloorOutboundEvent = {
  LIST_WORKSPACE: 'list_workspace',
  RETRIEVE_WORKSPACE: 'retrieve_workspace',
  WORKSPACES_CHANGED: 'workspaces_changed',
  WORKSPACE_CHANGED: 'workspace_changed',
  ROOM_CHANGED: 'room_changed',
  ROOM_DELETED: 'room_deleted',
  DOOR_DELETED: 'door_deleted',
  UPDATE_MEETINGROOM_STATUS: 'update_meetingroom_status',
  MEETINGROOM_UPDATED: 'meetingroom_updated',
  ERROR: 'error',
} as const;

export type FloorInboundEventName = typeof FloorInboundEvent[keyof typeof FloorInboundEvent];
export type FloorOutboundEventName = typeof FloorOutboundEvent[keyof typeof FloorOutboundEvent];
